import axios from 'axios';

export const downloadCensusTemplate = (templateUrl: string): Promise<void> => {
  return axios({
    url: templateUrl,
    method: 'GET',
    responseType: 'blob',
    withCredentials: true,
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'InsuranceMenu_Census.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
};
